import React, { useEffect, useState } from 'react';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/comprobantes_admin.php';
const token = () => localStorage.getItem('com_admin_token') || '';

const ESTADO = {
  '05': { label:'Aceptado',  bg:'#d1fae5', color:'#065f46' },
  '01': { label:'Pendiente', bg:'#fef3c7', color:'#92400e' },
  '09': { label:'Rechazado', bg:'#fee2e2', color:'#c53030' },
};



const MOCK = [
    { id:1, external_id:'ext-001', serie_numero:'B001-00001', tipo_doc:'03', estado:'05', aceptado_sunat:1, pdf_link:'#', created_at:'2026-09-19 10:30:00', pedido_codigo:'PED-2026-0117', nombre:'Dante Carranza', monto:80.00 },
    { id:2, external_id:'ext-002', serie_numero:'B001-00002', tipo_doc:'03', estado:'05', aceptado_sunat:1, pdf_link:'#', created_at:'2026-09-18 14:20:00', pedido_codigo:'PED-2026-0116', nombre:'Fernando Perez', monto:19.00 },
    { id:3, external_id:'ext-003', serie_numero:'F001-00001', tipo_doc:'01', estado:'01', aceptado_sunat:0, pdf_link:null, created_at:'2026-09-17 09:15:00', pedido_codigo:'PED-2026-0115', nombre:'Maria Gutierrez SAC', monto:230.00 },
    { id:4, external_id:'ext-004', serie_numero:'B001-00003', tipo_doc:'03', estado:'09', aceptado_sunat:0, pdf_link:null, created_at:'2026-09-16 16:45:00', pedido_codigo:'PED-2026-0114', nombre:'Carlos Quispe', monto:19.00 },
    { id:5, external_id:'ext-005', serie_numero:'B001-00004', tipo_doc:'03', estado:'05', aceptado_sunat:1, pdf_link:'#', created_at:'2026-09-15 11:00:00', pedido_codigo:'PED-2026-0113', nombre:'Isabel Torres', monto:120.00 },
  ];
  
  export default function AdminComprobantes() {
    const [comprobantes, setComprobantes] = useState(MOCK);
    const [loading,      setLoading]      = useState(false);
    const [filtroEstado, setFiltroEstado] = useState('');
    const [busqueda,     setBusqueda]     = useState('');
  
    useEffect(() => {
      setLoading(true);
      fetch(`${API}?action=list&estado=${filtroEstado}`, {
        headers: { Authorization: `Bearer ${token()}` }
      })
        .then(r => r.json())
        .then(j => { if (j.success && j.data?.length > 0) setComprobantes(j.data); })
            .catch(() => { setComprobantes(MOCK); })
            .finally(() => setLoading(false));
    }, [filtroEstado]);




  const reenviar = async (externalId) => {
    if (!window.confirm('¿Reenviar a SUNAT?')) return;
    const r = await fetch(`${API}?action=reenviar`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', Authorization:`Bearer ${token()}` },
      body: JSON.stringify({ external_id: externalId }),
    });
    const j = await r.json();
    alert(j.aceptado_por_sunat ? '✅ Aceptado por SUNAT' : '⚠️ ' + (j.sunat?.descripcion || 'No aceptado'));
    setFiltroEstado(f => f); // refetch
  };

  const filtrados = comprobantes.filter(c =>
    !busqueda ||
    c.serie_numero?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.pedido_codigo?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.nombre?.toLowerCase().includes(busqueda.toLowerCase())
  );


  

    // Stats
    const total     = comprobantes.length;
    const aceptados = comprobantes.filter(c => c.estado === '05').length;
    const pendientes= comprobantes.filter(c => c.estado === '01').length;
    const rechazados= comprobantes.filter(c => c.estado === '09').length;
    const montoTotal= comprobantes.filter(c => c.estado === '05').reduce((s,c) => s + Number(c.monto||0), 0);
  
    return (
      <div style={{padding:'2rem',fontFamily:'"DM Sans",sans-serif',maxWidth:1150,margin:'0 auto'}}>
  
        {/* Header */}
        <div style={{marginBottom:'1.5rem'}}>
          <h1 style={{fontSize:'1.5rem',fontWeight:700,color:'#111614',margin:0}}>Comprobantes electrónicos</h1>
          <p style={{margin:'.3rem 0 0',color:'#5a6a63',fontSize:'.88rem'}}>Boletas y facturas emitidas a SUNAT vía FactuSmart.</p>
        </div>
  
        {/* Stats */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'1rem',marginBottom:'1.5rem'}}>
          {[
            { label:'Total emitidos', value: total,                          color:'#032D29', bg:'#edfaf4' },
            { label:'Aceptados',      value: aceptados,                      color:'#065f46', bg:'#d1fae5' },
            { label:'Pendientes',     value: pendientes,                     color:'#92400e', bg:'#fef3c7' },
            { label:'Monto aceptado', value: `S/. ${montoTotal.toFixed(2)}`, color:'#1d4ed8', bg:'#dbeafe' },
          ].map((s,i) => (
            <div key={i} style={{background:'#fff',borderRadius:12,padding:'1rem 1.2rem',border:'1.5px solid rgba(139,202,175,.2)',boxShadow:'0 2px 8px rgba(0,0,0,.04)'}}>
              <p style={{margin:0,fontSize:'.75rem',fontWeight:700,color:'#5a6a63',textTransform:'uppercase',letterSpacing:'.06em'}}>{s.label}</p>
              <p style={{margin:'.3rem 0 0',fontSize:'1.5rem',fontWeight:800,color:s.color}}>{s.value}</p>
            </div>
          ))}
        </div>
  
        {/* Filtros */}
        <div style={{display:'flex',gap:'.75rem',marginBottom:'1.2rem',flexWrap:'wrap'}}>
          <input
            placeholder="🔍 Buscar por serie, pedido o cliente…"
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
            style={{flex:1,minWidth:220,padding:'.6rem 1rem',borderRadius:10,border:'1.5px solid rgba(139,202,175,.3)',fontFamily:'inherit',fontSize:'.88rem',outline:'none'}}
          />
          <select value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}
            style={{padding:'.6rem 1rem',borderRadius:10,border:'1.5px solid rgba(139,202,175,.3)',fontFamily:'inherit',fontSize:'.88rem',outline:'none',background:'#fff',color:'#111614'}}>
            <option value="">Todos los estados</option>
            <option value="05">✅ Aceptado</option>
            <option value="01">⏳ Pendiente</option>
            <option value="09">❌ Rechazado</option>
          </select>
        </div>
  
        {/* Tabla */}
        {loading ? (
          <div style={{textAlign:'center',padding:'3rem',color:'#5a6a63'}}>Cargando…</div>
        ) : filtrados.length === 0 ? (
          <div style={{textAlign:'center',padding:'3rem',color:'#5a6a63'}}>
            <p style={{fontSize:'2rem',marginBottom:'.5rem'}}>🧾</p>
            <p>No hay comprobantes que coincidan.</p>
          </div>
        ) : (
          <div style={{background:'#fff',borderRadius:14,border:'1.5px solid rgba(139,202,175,.2)',overflow:'hidden',boxShadow:'0 2px 12px rgba(0,0,0,.04)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'.85rem'}}>
              <thead>
                <tr style={{background:'#032D29'}}>
                  {['Fecha','Serie / Tipo','Pedido','Cliente','Monto','Estado','Acciones'].map(h => (
                    <th key={h} style={{padding:'.8rem 1rem',textAlign:'left',fontWeight:700,color:'#8BCAAF',fontSize:'.72rem',textTransform:'uppercase',letterSpacing:'.08em'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map((c, i) => {
                  const est = ESTADO[c.estado] || {label:c.estado,bg:'#f3f4f6',color:'#374151'};
                  return (
                    <tr key={i} style={{borderBottom:'1px solid rgba(139,202,175,.1)',transition:'background .15s'}}
                      onMouseEnter={e => e.currentTarget.style.background='#f9fffe'}
                      onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                      <td style={{padding:'.8rem 1rem',color:'#5a6a63',whiteSpace:'nowrap',fontSize:'.82rem'}}>
                        {new Date(c.created_at).toLocaleDateString('es-PE')}
                      </td>
                      <td style={{padding:'.8rem 1rem'}}>
                        <p style={{margin:0,fontWeight:700,color:'#111614',fontSize:'.88rem'}}>{c.serie_numero || '—'}</p>
                        <p style={{margin:'.1rem 0 0',fontSize:'.72rem',color:'#5a6a63'}}>
                          {c.tipo_doc === '01' ? '📄 Factura' : '🧾 Boleta'}
                        </p>
                      </td>
                      <td style={{padding:'.8rem 1rem',color:'#14736C',fontWeight:700,fontSize:'.85rem'}}>
                        {c.pedido_codigo || '—'}
                      </td>
                      <td style={{padding:'.8rem 1rem',color:'#111614',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {c.nombre || '—'}
                      </td>
                      <td style={{padding:'.8rem 1rem',fontWeight:800,color:'#111614',fontSize:'.95rem'}}>
                        S/. {Number(c.monto||0).toFixed(2)}
                      </td>
                      <td style={{padding:'.8rem 1rem'}}>
                        <span style={{fontSize:'.72rem',fontWeight:700,padding:'.3rem .8rem',borderRadius:100,background:est.bg,color:est.color,whiteSpace:'nowrap'}}>
                          {est.label}
                        </span>
                      </td>
                      <td style={{padding:'.8rem 1rem'}}>
                        <div style={{display:'flex',gap:'.4rem'}}>
                          {c.pdf_link && c.pdf_link !== '#' && (
                            <a href={c.pdf_link} target="_blank" rel="noopener noreferrer"
                              style={{fontSize:'.75rem',fontWeight:700,color:'#14736C',textDecoration:'none',
                                      padding:'.35rem .8rem',borderRadius:8,background:'#edfaf4',
                                      border:'1px solid rgba(139,202,175,.4)',whiteSpace:'nowrap'}}>
                              📥 PDF
                            </a>
                          )}
                          {c.estado === '01' && c.external_id && (
                            <button onClick={() => reenviar(c.external_id)}
                              style={{fontSize:'.75rem',fontWeight:700,color:'#fff',background:'#14736C',
                                      border:'none',borderRadius:8,padding:'.35rem .8rem',cursor:'pointer',
                                      fontFamily:'inherit',whiteSpace:'nowrap'}}>
                              🔄 Reenviar
                            </button>
                          )}
                          {c.estado === '09' && (
                            <span style={{fontSize:'.72rem',color:'#c53030',fontWeight:600}}>Emitir nuevo</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div style={{padding:'.8rem 1rem',background:'#f9fffe',borderTop:'1px solid rgba(139,202,175,.15)',fontSize:'.78rem',color:'#5a6a63'}}>
              Mostrando {filtrados.length} de {total} comprobantes
            </div>
          </div>
        )}
      </div>
    );
  }